import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import './css/myswal.css';

const MySwal = withReactContent(Swal).mixin({
  showCloseButton: true,
  closeButtonHtml: '×',
  buttonsStyling: false,
  reverseButtons: true,
  padding: 0,
  customClass: {
    header: 'bg_swal modal-header',
    title: 'modal-title',
    closeButton: 'close',
    content: 'swal-content-class',
    actions: 'modal-footer d-flex justify-content-between',
    confirmButton: 'bg_brand btn btn-primary',
    cancelButton: 'btn btn-light',
  }
})

const DangerSwal = withReactContent(Swal).mixin({
  showCloseButton: true,
  closeButtonHtml: '×',
  buttonsStyling: false,
  reverseButtons: true,
  padding: 0,
  customClass: {
    header: 'bg_swal modal-header',
    title: 'modal-title',
    closeButton: 'close',
    content: 'swal-content-class',
    actions: 'modal-footer d-flex justify-content-between',
    confirmButton: 'bg_danger btn btn-danger',
    cancelButton: 'btn btn-light',
  }
})

const IconSwal = withReactContent(Swal).mixin({
  buttonsStyling: false,
  reverseButtons: true,
  padding: 0,
  customClass: {
    header: 'bg_swal swal-icon-header justify-content-around',
    title: 'modal-title',
    icon: 'swal-icon-class',
    content: 'swal-content-class',
    actions: 'modal-footer d-flex justify-content-between',
    confirmButton: 'bg_brand btn btn-primary',
    cancelButton: 'btn btn-light',
  }
})

const AlertSwal = withReactContent(Swal).mixin({
  showCloseButton: true,
  closeButtonHtml: '×',
  buttonsStyling: false,
  padding: 0,
  customClass: {
    header: 'bg_swal modal-header',
    closeButton: 'close',
    content: 'swal-content-class font-weight-bold font-larger',
    title: 'modal-title',
    actions: 'modal-footer d-flex justify-content-center',
    confirmButton: 'bg_brand btn btn-primary'
  }
})

export { MySwal, AlertSwal, IconSwal, DangerSwal };